import { render, staticRenderFns } from "./ContactChecklist.vue?vue&type=template&id=4b84b882&"
import script from "./ContactChecklist.vue?vue&type=script&lang=js&"
export * from "./ContactChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContactChecklist.vue"
export default component.exports